import mixpanel, { Dict } from "mixpanel-browser";

export const maskPhone = (phone: string) => phone.replace(/\d(?=\d{4})/g, "*");

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN ?? "";

export const initMixpanel = () => {
	if (!MIXPANEL_TOKEN) return;
	mixpanel.init(MIXPANEL_TOKEN, {
		track_pageview: true,
		persistence: "localStorage"
	});
};

const Mixpanel = {
	identify: (id: string) => {
		if (!MIXPANEL_TOKEN) return;
		mixpanel.identify(id);
	},

	track: (event: string, properties?: Dict) => {
		if (!MIXPANEL_TOKEN) return;
		mixpanel.track(event, properties);
	},

	people: {
		set: (properties: Dict) => {
			if (!MIXPANEL_TOKEN) return;
			mixpanel.people.set(properties);
		}
	},

	reset: () => {
		if (!MIXPANEL_TOKEN) return;
		mixpanel.reset();
	}
};

export default Mixpanel;
